
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/livekit/button';
import { useUserName } from '@/hooks/useUserName';

interface WelcomeViewProps {
  onStartCall: () => void;
  isLoading?: boolean;
}

export const WelcomeView = ({
  onStartCall,
  isLoading = false,
  ref,
}: React.ComponentProps<'div'> & WelcomeViewProps) => {
  const { t } = useTranslation();
  const { userName, setUserName } = useUserName();

  const handleStartCall = () => {
    if (userName.trim()) {
      onStartCall();
    }
  };

  return (
    <div ref={ref} className="w-full max-w-full overflow-x-hidden">
      <section className="bg-background flex flex-col items-center justify-center text-center px-4 sm:px-6 w-full max-w-full overflow-hidden box-border">
        <div className="flex flex-col items-center gap-2">
          {t('welcome.badge') && (
            <span className="rounded-full bg-accent px-3 py-1 text-xs font-semibold text-accent-foreground uppercase tracking-wide">
              {t('welcome.badge')}
            </span>
          )}
          <p className="text-foreground max-w-xl pt-1 text-lg leading-7 font-semibold">
            {t('welcome.title')}
          </p>
          {t('welcome.description') && (
            <p className="text-muted-foreground max-w-2xl text-sm leading-6">
              {t('welcome.description')}
            </p>
          )}
        </div>

        <div className="mt-6 w-full max-w-xs">
          <label htmlFor="user-name" className="block text-sm font-medium text-foreground mb-2 text-left">
            {t('welcome.userNameLabel')}
          </label>
          <input
            id="user-name"
            type="text"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            placeholder={t('welcome.userNamePlaceholder')}
            className="w-full px-4 py-2 rounded-lg border border-border bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          />
        </div>

        <Button
          variant="primary"
          size="lg"
          onClick={handleStartCall}
          disabled={isLoading || !userName.trim()}
          className="mt-4 w-64 font-semibold"
        >
          {isLoading ? 'Loading...' : t('welcome.startButton')}
        </Button>

        {/* Dashboard preview for upcoming analysis features */}
        {/* <div className="mt-6 w-full max-w-4xl space-y-3 text-left" style={{ overflow: 'hidden', maxWidth: 'min(100%, 56rem)' }}>
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">Insights Dashboard</p>
              <p className="text-muted-foreground text-sm">Designed for post-call analysis and theme-grouped insights (coming soon).</p>
            </div>
            <span className="text-xs font-semibold text-primary">Preview</span>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <div className="bg-card/70 border-border rounded-xl border p-3 shadow-sm">
              <p className="text-sm font-semibold text-foreground">Interview analysis</p>
              <p className="text-muted-foreground text-xs mt-1">Placeholder for transcript scoring, highlights, and coach-style guidance.</p>
              <div className="mt-3 space-y-2 text-xs">
                <div className="flex items-center justify-between rounded-md bg-muted/40 px-2 py-2">
                  <span className="text-muted-foreground">Completion</span>
                  <span className="font-mono text-foreground">—%</span>
                </div>
                <div className="flex items-center justify-between rounded-md bg-muted/40 px-2 py-2">
                  <span className="text-muted-foreground">Key moments</span>
                  <span className="font-mono text-foreground">0</span>
                </div>
                <div className="flex items-center justify-between rounded-md bg-muted/40 px-2 py-2">
                  <span className="text-muted-foreground">Action items</span>
                  <span className="font-mono text-foreground">0</span>
                </div>
              </div>
            </div>

            <div className="bg-card/70 border-border rounded-xl border p-3 shadow-sm">
              <p className="text-sm font-semibold text-foreground">Themes & grouped insights</p>
              <p className="text-muted-foreground text-xs mt-1">Buckets for sentiment, objections, motivations, and product feedback.</p>
              <div className="mt-3 space-y-2 text-xs">
                <div className="rounded-md bg-muted/40 px-2 py-2">
                  <p className="text-foreground font-medium">Sentiment</p>
                  <p className="text-muted-foreground">Positive / Neutral / Risk</p>
                </div>
                <div className="rounded-md bg-muted/40 px-2 py-2">
                  <p className="text-foreground font-medium">Top themes</p>
                  <p className="text-muted-foreground">E.g., Pricing, UX, Support, Performance</p>
                </div>
                <div className="rounded-md bg-muted/40 px-2 py-2">
                  <p className="text-foreground font-medium">Next steps</p>
                  <p className="text-muted-foreground">Route insights to owners with tags.</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </div>
  );
};
